var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        { attrs: { "max-width": "1000px", persistent: "", value: true } },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("travelService.orderRail")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c("multiple-user-select", {
                        attrs: {
                          "birth-date-required":
                            _vm.$store.getters["userProperties"].system_settings
                              .travel_service_rail_insurance ===
                            _vm.insuranceTypeID.INSURANCE_ADD
                        }
                      }),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "px-2", attrs: { cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.availableClasses,
                                  label: _vm.$t("travelService.class") + "*",
                                  rules: [_vm.validatorIsRequired]
                                },
                                model: {
                                  value:
                                    _vm.contextModel.travelServiceOrderItemRail
                                      .seat_class,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemRail,
                                      "seat_class",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemRail.seat_class"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("location-ajax-select", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.departureRailPlace") +
                                    "*",
                                  placeholder: _vm.$t(
                                    "travelService.enterCountry"
                                  ),
                                  rules: [_vm.validatorIsRequired],
                                  "select-model":
                                    _vm.contextModel.travelServiceOrderItemRail
                                      .start_place_id,
                                  type: "train_station"
                                },
                                on: {
                                  "update:selectModel": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemRail,
                                      "start_place_id",
                                      $event
                                    )
                                  },
                                  "update:select-model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemRail,
                                      "start_place_id",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("location-ajax-select", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.arrivalRailPlace") +
                                    "*",
                                  placeholder: _vm.$t(
                                    "travelService.enterCountry"
                                  ),
                                  rules: [_vm.validatorIsRequired],
                                  "select-model":
                                    _vm.contextModel.travelServiceOrderItemRail
                                      .end_place_id,
                                  type: "train_station"
                                },
                                on: {
                                  "update:selectModel": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemRail,
                                      "end_place_id",
                                      $event
                                    )
                                  },
                                  "update:select-model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemRail,
                                      "end_place_id",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("date-picker", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.departureRailDate") +
                                    "*",
                                  max:
                                    _vm.contextModel.travelServiceOrderItemRail
                                      .return_date,
                                  model:
                                    _vm.contextModel.travelServiceOrderItemRail
                                      .start_date,
                                  rules: [
                                    _vm.validatorIsRequired,
                                    _vm.validatorIsFutureDate
                                  ]
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemRail,
                                      "start_date",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("time-picker", {
                                attrs: {
                                  label: _vm.$t(
                                    "travelService.departureRailTime"
                                  ),
                                  model:
                                    _vm.contextModel.travelServiceOrderItemRail
                                      .start_time,
                                  placeholder: _vm.$t("travelService.any"),
                                  "prepend-icon": ""
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemRail,
                                      "start_time",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: _vm.$t("travelService.isReturnRoute")
                                },
                                model: {
                                  value: _vm.isReturnRoute,
                                  callback: function($$v) {
                                    _vm.isReturnRoute = $$v
                                  },
                                  expression: "isReturnRoute"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.isReturnRoute
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "12", sm: "6" }
                                },
                                [
                                  _c("date-picker", {
                                    attrs: {
                                      label:
                                        _vm.$t("travelService.returnRailDate") +
                                        "*",
                                      min:
                                        _vm.contextModel
                                          .travelServiceOrderItemRail
                                          .start_date,
                                      model:
                                        _vm.contextModel
                                          .travelServiceOrderItemRail
                                          .return_date,
                                      rules: [
                                        _vm.validatorIsRequired,
                                        _vm.validatorIsFutureDate
                                      ]
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextModel
                                            .travelServiceOrderItemRail,
                                          "return_date",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isReturnRoute
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "12", sm: "6" }
                                },
                                [
                                  _c("time-picker", {
                                    attrs: {
                                      label: _vm.$t(
                                        "travelService.returnRailTime"
                                      ),
                                      model:
                                        _vm.contextModel
                                          .travelServiceOrderItemRail
                                          .return_time,
                                      placeholder: _vm.$t("travelService.any"),
                                      "prepend-icon": ""
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextModel
                                            .travelServiceOrderItemRail,
                                          "return_time",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("cost-centre-select", {
                                attrs: { value: _vm.contextModel.cost_centre },
                                on: {
                                  "update:value": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel,
                                      "cost_centre",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "px-2", attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: _vm.$t("global.comment") },
                                model: {
                                  value: _vm.contextModel.comment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.contextModel, "comment", $$v)
                                  },
                                  expression: "contextModel.comment"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.formValid,
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [_vm._v("Ok")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }